
import { getCurrentUser } from "@aws-amplify/auth";
import { fetchUserAttributes } from '@aws-amplify/auth';

export async function redirectToOriginSubdomain() {
  try {
    const [user, attrs] = await Promise.all([
      getCurrentUser(),
      fetchUserAttributes(),
    ]);

    if (user && attrs) {
      const attributes = attrs;
      console.debug(attributes?.["custom:Origin"]);
      const origin = attributes?.["custom:Origin"];
      if (!origin) return;
      const originalUrl = sessionStorage.getItem("initialFullUrl") || window.location.href;
      if (origin == "bergmann") {
        const newUrl = "https://bergmann.portal.bankszamlakivonat.hu"//originalUrl.replace(/^https:\/\//, `https://bergmann.`);

        //const newUrl = `${protocol}//${origin}.${hostname}${pathname}${search}${hash}`;
        console.log("[OriginRedirect] Redirecting →", newUrl);

        window.location.href = newUrl;
      }
      if (origin == "mbh") {
        const newUrl = originalUrl.replace(/^https:\/\//, `https://mbh.`);

        //const newUrl = `${protocol}//${origin}.${hostname}${pathname}${search}${hash}`;
        console.log("[OriginRedirect] Redirecting →", newUrl);

        window.location.href = newUrl;
      }
    };
  } catch (err) {
    console.debug("[OriginRedirect] Skip redirect:", err.message);
  }
}
